import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useCallback, useEffect, useRef, useState } from "react";
import { useStickyState } from "@crehana/react-hooks";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Snackbar } from "@crehana/ui";
import useNewDashboardTranslations from "../hooks/useNewDashboardTranslations";
import { defaultContext } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var NewDashboardContext = /*#__PURE__*/createContext(defaultContext);
var NewDashboardContextProvider = function NewDashboardContextProvider(_ref) {
  var user = _ref.user,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    source = _ref.source,
    toggleTheme = _ref.toggleTheme,
    initialRoute = _ref.initialRoute,
    onRouteChangeProp = _ref.onRouteChange,
    children = _ref.children;
  var _useNewDashboardTrans = useNewDashboardTranslations(),
    t = _useNewDashboardTrans.t;
  var sectionRef = useRef(null);
  var _useStickyState = useStickyState(false, 'homeUserSidebarCollapsed'),
    _useStickyState2 = _slicedToArray(_useStickyState, 2),
    sidebarCollapsed = _useStickyState2[0],
    setSidebarCollapsed = _useStickyState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileSidebarOpen = _useState2[0],
    setMobileSidebarOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    designMode = _useState4[0],
    setDesignMode = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    currentRoute = _useState6[0],
    setCurrentRoute = _useState6[1];
  var scrollTop = useCallback(function () {
    if (sectionRef.current) {
      sectionRef.current.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, []);
  var _useState7 = useState({
      isOpen: false,
      message: t('GENERAL_ERROR')
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    errorSnackbar = _useState8[0],
    setErrorSnackbar = _useState8[1];
  var toggleMobileSideBar = useCallback(function (newState) {
    setMobileSidebarOpen(function (prev) {
      return typeof newState === 'boolean' ? newState : !prev;
    });
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var openErrorSnackbar = useCallback(function (message) {
    setErrorSnackbar({
      isOpen: true,
      message: message || t('GENERAL_ERROR')
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var closeErrorSnackbar = useCallback(function () {
    setErrorSnackbar(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isOpen: false
      });
    });
  }, []);
  var openSideBar = useCallback(function () {
    setSidebarCollapsed(false);
  }, [setSidebarCollapsed]);
  var closeSideBar = useCallback(function () {
    setSidebarCollapsed(true);
  }, [setSidebarCollapsed]);
  var toggleSideBar = useCallback(function () {
    setSidebarCollapsed(function (prevState) {
      return !prevState;
    });
  }, [setSidebarCollapsed]);
  var updateCurrentRoute = useCallback(function (route) {
    setCurrentRoute(route);
  }, []);
  useEffect(function () {
    if (initialRoute) {
      updateCurrentRoute(initialRoute);
    }
  }, [initialRoute, updateCurrentRoute]);
  var onRouteChange = useCallback(function (route) {
    if (!route.openInNewTab && !route.isExternal) {
      updateCurrentRoute(route);
    }
    onRouteChangeProp(route);
  }, [onRouteChangeProp, updateCurrentRoute]);
  var value = {
    mobileSidebarOpen: mobileSidebarOpen,
    sidebarCollapsed: sidebarCollapsed,
    currentRoute: currentRoute,
    toggleTheme: toggleTheme,
    designMode: designMode,
    sectionRef: sectionRef,
    source: source,
    isDark: isDark,
    user: user,
    scrollTop: scrollTop,
    openSideBar: openSideBar,
    closeSideBar: closeSideBar,
    toggleSideBar: toggleSideBar,
    toggleDesignMode: setDesignMode,
    openErrorSnackbar: openErrorSnackbar,
    updateCurrentRoute: updateCurrentRoute,
    toggleMobileSideBar: toggleMobileSideBar,
    onRouteChange: onRouteChange
  };
  var snackbar = process.env.NODE_ENV === 'test' ? undefined : /*#__PURE__*/_jsx(Snackbar, {
    open: errorSnackbar.isOpen,
    onDismiss: closeErrorSnackbar,
    message: errorSnackbar.message,
    state: "alert",
    position: "top-right",
    showCloseBtn: true,
    isDark: isDark
  });
  return /*#__PURE__*/_jsxs(NewDashboardContext.Provider, {
    value: value,
    children: [children, snackbar]
  });
};
export default NewDashboardContextProvider;